import {
  selectFacetSchemaEnhancer,
  selectFacetStateToValue,
  selectFacetValueToQuery,
} from '@plone/volto/components/manage/Blocks/Search/components/base';
import React from 'react';
import { Button, Checkbox, Header } from 'semantic-ui-react';
import { defineMessages, injectIntl } from 'react-intl';
import './TagButtonFacet.css';
import { isTagField } from './tagWhitelistEnhancer';

const messages = defineMessages({
  showAll: {
    id: 'Show All',
    defaultMessage: 'Show All',
  },
});

const filterChoicesByWhitelist = (choices, whitelist) => {
  if (!whitelist) {
    return choices;
  }

  let whitelistArray = whitelist;

  // Handle base64-encoded data (convert to array)
  if (typeof whitelist === 'string') {
    try {
      // Try to decode base64 first
      const decoded = atob(whitelist);
      // If decoded string contains multiple values, split them
      whitelistArray = decoded.includes(',') ? decoded.split(',') : [decoded];
    } catch (e) {
      // If not valid base64, treat as single string value
      whitelistArray = [whitelist];
    }
  }

  // Handle array format
  if (!Array.isArray(whitelistArray)) {
    whitelistArray = [whitelistArray];
  }

  if (whitelistArray.length === 0) {
    return choices;
  }

  return choices.filter((choice) => whitelistArray.includes(choice.value));
};

const WhitelistCheckboxFacet = (props) => {
  const { facet, choices, isMulti, onChange, value, isEditMode, intl } = props;
  const facetValue = value;

  // Use the actual tag whitelist from the facet configuration
  const filteredChoices = isTagField(facet?.field?.value)
    ? filterChoicesByWhitelist(choices, facet?.tagWhitelist)
    : choices;

  const hasSelection = isMulti
    ? facetValue && facetValue.length > 0
    : facetValue;

  const handleReset = () => {
    onChange(facet.field.value, isMulti ? [] : null);
  };

  return (
    <div className="checkbox-facet tag-button-facet">
      <Header as="h4">{facet.title ?? facet?.field?.label}</Header>
      <div className="tag-buttons-container">
        {/* Reset/Show All button */}
        {hasSelection && (
          <Button
            basic
            size="small"
            className="tag-reset-button"
            disabled={isEditMode}
            onClick={handleReset}
          >
            {intl.formatMessage(messages.showAll)}
          </Button>
        )}

        {/* Tag buttons */}
        <div className="tag-buttons">
          {filteredChoices.map(({ label, value: choiceValue }) => {
            const isChecked = isMulti
              ? !!facetValue?.find((f) => f.value === choiceValue)
              : facetValue && facetValue.value === choiceValue;

            return (
              <div className="tag-button-wrapper" key={choiceValue}>
                <Checkbox
                  id={choiceValue}
                  disabled={isEditMode}
                  label={label}
                  radio={!isMulti}
                  checked={isChecked}
                  onChange={(_, { checked }) => {
                    const newValue = isMulti
                      ? [
                          ...(facetValue || [])
                            .filter((f) => f.value !== choiceValue)
                            .map((f) => f.value),
                          ...(checked ? [choiceValue] : []),
                        ]
                      : checked
                        ? choiceValue
                        : null;
                    onChange(facet.field.value, newValue);
                  }}
                  className={`tag-button-checkbox ${isChecked ? 'checked' : ''}`}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

// Attach the static properties - use original schema enhancer since we handle tagWhitelist in shadow schema
WhitelistCheckboxFacet.schemaEnhancer = selectFacetSchemaEnhancer;
WhitelistCheckboxFacet.stateToValue = selectFacetStateToValue;
WhitelistCheckboxFacet.valueToQuery = selectFacetValueToQuery;

export default injectIntl(WhitelistCheckboxFacet);
